import * as Yup from 'yup';
import { Tag } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Tag>().shape({
    name: Yup.string().nullable().required(),
  });
}
